import { FC } from "react";
import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal";
import "./UploadResultModal.scss";

export interface UploadResultData {
  productsAccepted: number;
  productsMovedForReview: number;
  productsSkippedDueToPriority: number;
}

interface UploadResultModalProps {
  isOpen: boolean;
  handleClose: () => void;
  uploadResults: UploadResultData;
}

const UploadResultModal: FC<UploadResultModalProps> = ({
  isOpen,
  handleClose,
  uploadResults,
}) => {
  return (
    <div className="upload-result-modal">
      <Modal
        handleClose={handleClose}
        open={isOpen}
        headingId="upload-result-modal"
      >
        <ModalHeading element="h5" style={{ color: "#e55000" }}>
          File Upload Successful
        </ModalHeading>

        <div className="modal-body">
          <ul>
            <li>
              <b>Products Accepted:</b>{" "}
              {uploadResults.productsAccepted}
            </li>
            <li>
              <b>Products Moved for Review:</b>{" "}
              {uploadResults.productsMovedForReview}
            </li>
            <li>
              <b>Products Skipped Due to Priority:</b>{" "}
              {uploadResults.productsSkippedDueToPriority}
            </li>
          </ul>
        </div>
      </Modal>
    </div>
  );
};

export default UploadResultModal;
